'use client';

import { useTranslations } from 'next-intl';
import { FC } from 'react';
import styles from './EntryPoint.module.scss';
import Image from 'next/image';
import { listingTypes } from '@/hotdesk-ui/constants/listing-types.constant';
import SearchSuggestionsDropdown from '@/hotdesk-ui/components/shared/SearchSuggestionsDropdown';
import { useSearchAutocomplete } from '@/hotdesk-ui/hooks/useSearchAutocomplete';
import { GeoCodeResult } from '@/hotdesk-ui/types/geo-code-result.type';
interface EntryPointProps {
  getPermission: () => void;
  sentData: () => void;
  autocompleteContainer: any;
  autocompleteInput: any;
  addFilters: (value: number) => void;
  listingType: number | undefined;
  /** Called when a place is picked from the suggestions dropdown. */
  onSelect: (result: GeoCodeResult) => void;
}
export const EntryPoint: FC<EntryPointProps> = ({
  getPermission,
  sentData,
  autocompleteInput,
  autocompleteContainer,
  addFilters,
  listingType,
  onSelect
}) => {
  const t = useTranslations();
  const {
    containerRef,
    predictions,
    activeIndex,
    isOpen: suggestionsOpen,
    setActiveIndex,
    selectByIndex
  } = useSearchAutocomplete({
    inputRef: autocompleteInput,
    onSelect
  });
  return <div className={`d-flex align-items-center ${styles.searchSec}`} data-sentry-component="EntryPoint" data-sentry-source-file="EntryPoint.tsx">
            <div className={`${styles.searchInput} py-md-2`}>
                <div className="autocomplete-container" ref={autocompleteContainer}>
                    <div className={`input-wrapper ${styles.inputWrapper}`} ref={containerRef} style={{
          position: 'relative'
        }}>
                        <div className={`filters d-none d-md-flex px-md-3 py-0 mb-2 ${styles.filters}`}>
                            <div className="d-flex justify-content-between w-100">
                                {listingTypes.map((type: {
                type: string;
                value: number;
              }, index: number) => <div key={index}>
                                            <p key={index} className={`m-0 mx-3 ${listingType == type.value ? `active ${styles.active}` : `inactive ${styles.inactive}`}`} onClick={() => addFilters(type.value)}>
                                                {t(`listingType.${type.type.replace(' ', '-')}`)}
                                            </p>
                                        </div>)}
                            </div>
                        </div>
                        <div className="d-flex">
                            <input ref={autocompleteInput} className={`form-control with-icon ${styles.formControl}`} placeholder={t('search-placeholder')} autoCorrect="off" autoCapitalize="off" spellCheck="false" type="text" />
                            <div className={`images d-flex ${styles.images}`}>
                                <Image className={`link gps-img mx-2 ${styles.gpsimg}`} alt="gps-img" src="/assets/icons/gps.svg" width={20} height={20} onClick={getPermission} data-sentry-element="Image" data-sentry-source-file="EntryPoint.tsx" />
                                <div className={`link search-img ${styles.searchImg}`} onClick={() => sentData()}>
                                    <Image alt="search-img" width={20} height={20} src="/assets/icons/search.svg" data-sentry-element="Image" data-sentry-source-file="EntryPoint.tsx" />
                                </div>
                            </div>
                        </div>
                        {suggestionsOpen && <SearchSuggestionsDropdown predictions={predictions} activeIndex={activeIndex} onHover={setActiveIndex} onSelect={selectByIndex} />}
                    </div>
                </div>
            </div>
        </div>;
};